import { flow } from 'lodash'

export const adjustToRange = (min: number, max: number) => flow([x => Math.max(x, min), x => Math.min(x, max)])

export { getRandomIndexFromArray, getRandomValueFromArray, sortBy } from './arrayUtils'
export { getRandomInt } from './random'
export { flow }
